<template>
  <div>

        <section class="gen-list">
          <div class="container">
            <div class="gs-head">
              <h2>{{ xgroup ? xgroup.title : "Latest Content" }}</h2>
            </div>
            <ul class="gen-list-content">
              <li v-for="item in items" :class="{vid: item.media && item.media.store.id!=1, multi: item.allVideos.length}">
                <div class="preview">
                  <img v-if="item.media && mediaUrl(item.media).indexOf('pdf')==-1" :src="mediaUrl(item.media, item)" />
                  <span class="video"></span>
                  <span class="cat">{{ item.type && item.type.title }}</span>
                  <span class="stat">{{ "" }}</span>
                </div>
                <div class="desc">
                  <h5><a href="">
                    <em v-if="item.parent?item.parent.subtitle:item.subtitle">{{ item.parent?item.parent.subtitle:item.subtitle }}</em>
                    <span v-html="formatTitle(item.title)"></span>
                  </a></h5>
                  <ul class="related" v-if="item.allVideos.length">
                    <template v-for="(relVideo, ri) in item.allVideos">
                      <li v-if="ri<3">{{ relVideo.title }}</li>
                      <li v-else-if="ri==3">and {{ item.allVideos.length-3 }} more...</li>
                    </template>
                  </ul>
                  <p v-else>{{ introText(item) }}</p>
                  <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date>
                </div>
                <div class="payment" v-for="payment in [paymentForVideo(item.id)]" v-if="payment">
                  <p class="subscribed">
                    <span>Expires:</span>
                    <em>{{ formatDate(payment.endDate, "MMM Do YYYY") }}</em>
                  </p>
                </div>
                <router-link :to="{name: 'content', params: {id: item.id}}" class="wlink"></router-link>
              </li>
              <li class="no-results" v-if="loading">
                Loading... Please wait.
              </li>
              <li class="no-results" v-else-if="!items.length">
                <template v-if="$route.params.category && $route.params.category.startsWith('ppatt') && (!currentUser || !currentUser.hasPpatt)">
                  You have to be a PPATT student to be granted access to this content. Please contact Kathi for more information.
                </template>
                <template v-else>
                  Currently we have no video uploaded matching your search.
                </template>
              </li>

            </ul>
          </div>
        </section>



  </div>
</template>
<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import dateLimit from './dateLimit';
import formatters from './formatters';
import payment from './payment';

export default {
  mixins: [mainNav, dateLimit, formatters, payment],
  data: ()=>({
    loading: true,
    xgroup: null,
    items: [],
    categories: [],
    latestItems: [],
    searchTerm: '',
    languages: {
      'English': "en",
      'French': "fr",
      'German': "de",
      'Turkish': "tr",
      'Japanese': "jp",
      'Spanish': "sp",
      'Portuguese': "pt",
      'Russian': "ru",
    },
  }),
  computed: {
    currentUser() {
      return appRoot.loggedIn;
    },
    isPpattCategory() {
      var catg=this.categories.find((a)=>a.slug==this.$route.params.category);
      while(catg && catg.parent)
        catg=this.categories.find((a)=>a.id==catg.parent);
      if (catg.id==4)
        return true;
      return false;
    },
    
  },
  methods: {
    async loadGroup(id) {
      this.xgroup=(await api.get("VideoGroup", id)).item;
    },
    async loadItems() {
      this.categories=(await api.list("VideoType", {})).items;
      var q={}
      if (this.$route.query.q) {
        q.title=["LIKE :base_title OR base.subtitle LIKE", "%"+this.$route.query.q+"%"];
      }
      if (!appRoot.loggedIn || !appRoot.loggedIn.hasPpatt) {
        q.password='null'
        if (this.isPpattCategory)
          q.password='---------';
      }
      if (!this.$route.params.category) {
        this.loadLatestPerCat();
      }
      if (this.$route.params.category) {
        var catgid=0;
        for(var category of this.categories)
          if (category.slug==this.$route.params.category)
            catgid=category.id;
        if (catgid) {
          var catgToIncl=[catgid];
          for(var catg2 of this.categories) {
            if (catgToIncl.indexOf(catg2.id)!=-1)
              continue;
            if (catgToIncl.indexOf(catg2.parent)!=-1)
              catgToIncl.push(catg2.id);
          }
          for(var catg2 of this.categories) {
            if (catgToIncl.indexOf(catg2.id)!=-1)
              continue;
            if (catgToIncl.indexOf(catg2.parent)!=-1)
              catgToIncl.push(catg2.id);
          }
          q.type=["FIND_IN_SET(base.type, '"+(catgToIncl.join(","))+"')<>", 0, ""];
        }
      }
      if (this.$route.params.filter) {
        var filterParts=this.$route.params.filter.
          split("-").filter((a)=>a).map((a)=>a.split("="));
        for(var part of filterParts) {
          if (part[0]=="a")
            q.aparatus=["FIND_IN_SET('"+(part[1]*1)+"', base.aparatus)<>", 0, ""];
          if (part[0]=="p")
            q.prop=["FIND_IN_SET('"+(part[1]*1)+"', base.prop)<>", 0, ""];
          if (part[0]=="s")
            q.speciality=["FIND_IN_SET('"+(part[1]*1)+"', base.speciality)<>", 0, ""];
        }
      }
      if (this.$route.params.group) {
        q.group_id=this.$route.params.group;
        this.loadGroup(q.group_id);
      }
      if (!q.group_id)
        var items=(await api.list("Video", q, ["created:DESC"])).items;
      else
        var items=(await api.list("Video", q, ["created:DESC"])).items;
      
      items.sort((a,b)=>{
        if (a.created<b.created) return 1;
        if (a.created>b.created) return -1;
        return 0;
      });
      var usedGroups={};
      var items2=[];
      for(var item of items) {
        if (!usedGroups[item.parent?item.parent.id:item.id]) {
          usedGroups[item.parent?item.parent.id:item.id]=true;
          items2.push(item);
        }
      }
      this.loading=false;
      this.items=items2;
    },
    async loadLatestPerCat() {
      var latestPromises=this.categories.map((a)=>api.list("Video", {type: a.id}, ["created:DESC"], 1));
      var latestResult=await Promise.all(latestPromises);
      for(var res of latestResult)
        if (res.items && res.items.length)
          this.latestItems.push(res.items[0]);
    },
    mediaUrl(obj, item) {
      if (item && item.thumbnail) {
        var media=item.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
       if (obj.store.plugin=='Video2')
        return obj.thumbnail;
      else if (obj.thumbnail && obj.store.plugin!="Local")
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    introText(item) {
      var text=[];
      var blocks=(item.blocks || []).slice().sort((a,b)=>{
        if (a.order_index<b.order_index) return -1;
        if (a.order_index>b.order_index) return 1;
        return 0;
      });
      for(var block of blocks) {
        text.push(block.content);
      }
      text=text.map((a)=>a.replace(/\<[^>]*\>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&[a-z]+;/g, ""));
      return text.join(" ").substring(0, 180);
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },
  mounted() {
    this.loadItems();
    this.loadTags();
    if (this.$route.params.category===undefined)
      this.menuItems[0].active=true;
    else if (this.$route.params.category==="webinars")
      this.menuItems[1].active=true;
    else if (this.$route.params.category==="classes")
      this.menuItems[2].active=true;
  },
}
</script>
